export var SupportInfoItemType = /*#__PURE__*/function (SupportInfoItemType) {
  SupportInfoItemType["call"] = "call";
  SupportInfoItemType["chat"] = "chat";
  SupportInfoItemType["phone"] = "phone";
  return SupportInfoItemType;
}({});